// extracted by css-extract-rspack-plugin
export default {"root":"root-2SJnN","disabled":"disabled-1P-ua","toggled":"toggled-3pR2s"};